module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-512x512-44d58176aaaf6542a776723a34453e0a.png";